// extracted by mini-css-extract-plugin
export var card = "card-module--card--cfpKk";
export var card_heading_left = "card-module--card_heading_left--lpW9T";
export var card_vertical = "card-module--card_vertical--mLyGv";
export var faq = "card-module--faq--JC1A2";
export var footer = "card-module--footer--A7h0M";
export var grey = "card-module--grey--274uL";
export var header_main = "card-module--header_main--BIJtA";
export var header_top = "card-module--header_top--mKohf";
export var join = "card-module--join--wEi8j";
export var last_news = "card-module--last_news--CWKv0";
export var opportunity = "card-module--opportunity--9ehYb";
export var partners = "card-module--partners--pqxXZ";
export var platform = "card-module--platform--IaOPw";
export var primary = "card-module--primary--hIaSn";
export var start = "card-module--start--w7qjz";